var AddressVoData = /** @class */ (function () {
    function AddressVoData(id) {
        this._id = id;
    }
    Object.defineProperty(AddressVoData.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    return AddressVoData;
}());
export { AddressVoData };
//# sourceMappingURL=address-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/address/address-vo-data.js
// module id = 911
// module chunks = 14